import React from 'react';

import { useDispatch } from 'react-redux';

import AddMinusButton from 'components/shared/AddMinusButton';
import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import i18n from 'i18n';
import { createRelocationsItemAction } from 'store/itinerariesItem';

import s from './index.module.css';

export function TableButtons(props) {
  const { isReadonly, openWhatAddModal, showSecondButton, disabled } = props;
  const dispatch = useDispatch();

  if (isReadonly || showSecondButton) {
    const handleClick = () => {
      if (isReadonly) return;
      openWhatAddModal();
    };
    return (
      <Button disabled={disabled} htmlType="button" onClick={handleClick} className={s.buttonsWrapper}>
        {i18n.t('proposal_content.guest_portal.flight_and_transfers_page.add_flight_or_transfer')}
      </Button>
    );
  }

  return (
    <FormActions isCenter marginTop className={s.buttonsWrapper}>
      <AddMinusButton onClick={() => dispatch(createRelocationsItemAction())} />
    </FormActions>
  );
}
